import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@cimpress/react-components';

class DrawerWrapper extends Component {
  static defaultProps = {};

  static propTypes = {
    drawerChildren: PropTypes.node,
    onOpenDrawer: PropTypes.func
  };

  state = {
    open: false
  };

  openDrawer = () => {
    !this.state.open && this.props.onOpenDrawer();
    !this.state.open && this.setState({ open: true });
  };

  closeDrawer = () => {
    this.setState({ open: false });
  };

  render() {
    const { drawerChildren, children, footer, ...rest } = this.props;
    return (
      <div onClick={this.openDrawer}>
        <Drawer show={this.state.open} onRequestHide={this.closeDrawer} footer={this.state.open && footer} {...rest}>
          {this.state.open && drawerChildren}
        </Drawer>
        {children}
      </div>
    );
  }
}

export default DrawerWrapper;
